<template>
  <div class="w-full h-5 bg-gray-100 rounded-full overflow-hidden mb-2.5 relative shadow-inner">
    <template v-if="preparing">
      <div
        class="absolute inset-0 flex items-center justify-center gap-2 bg-gray-50 text-xs text-gray-600"
      >
        <div
          class="w-3 h-3 border-2 border-green-500 border-t-transparent rounded-full animate-spin"
        ></div>
        <span>Preparing for upload...</span>
      </div>
    </template>
    <template v-else>
      <div
        class="h-full bg-green-500 transition-all duration-300 ease-in-out"
        :style="{ width: `${progress}%` }"
      ></div>
      <div class="absolute inset-0 text-center leading-5 text-black text-xs truncate px-2.5">
        {{ progressText }}
      </div>
    </template>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';

interface UploadProgressProps {
  progress: number;
  fileName: string;
  preparing?: boolean;
}

const props = defineProps<UploadProgressProps>();

const progressText = computed(() => {
  return `${props.fileName}: ${props.progress.toFixed(2)}%`;
});
</script>
